import { call, fork, put, takeEvery } from 'redux-saga/effects';

import actionTypes from '@atom/actions/actionTypes';
import * as workTemplateActions from '@atom/actions/workTemplateActions';
import accountUtilities from '@atom/utilities/accountUtilities';
import api from '@atom/utilities/api';
import { WORK_TEMPLATES_ENDPOINT } from '@atom/utilities/endpoints';
import { TOTAL_COUNT_HEADER } from '@atom/utilities/requestUtilities';

export function* getWorkTemplates(action: any): any {
  try {
    const { page, limit } = action.data;
    const params = {
      ...(page ? { page } : {}),
      ...(limit ? { limit } : {}),
    };

    const { data, headers } = yield call(
      api.get,
      WORK_TEMPLATES_ENDPOINT,
      params,
    );
    yield put(workTemplateActions.getWorkTemplatesSuccess(data));
    yield put(
      workTemplateActions.getWorkTemplatesTotalSuccess(
        Number(headers[TOTAL_COUNT_HEADER]),
      ),
    );
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      workTemplateActions.getWorkTemplatesFailure,
    );
  }
}

/* WATCHERS */

export function* requestWorkTemplates(): any {
  yield takeEvery(actionTypes.REQUEST_WORK_TEMPLATES, getWorkTemplates);
}

export default [requestWorkTemplates];
